export enum CheckInStatuses {
    CheckedIn = 1,
    DriverNotified = 2,
    Fulfilled = 3,
    NotFulFilled = 4,
}
